import { Row, Col, Alert } from 'react-bootstrap';

function BusinessSearchResourcesNotice() {
  if (window.location.hostname === 'app.caat.io') {
    return null;
  }

  return (
    <Row>
      <Col className="text-center">
        <Alert variant="info" className="my-24">
          <p className="mb-0">
            If you are interested in other resources to help your
            business, please visit the{' '}
            {window.location.hostname === 'al.caat.io' ? (
              <a
                rel={'noreferrer'}
                href="https://www.asbdc.org/office-locations/"
                target="_blank"
              >
                Alabama Small Business Development Center.
              </a>
            ) : (
              <a
                rel={'noreferrer'}
                href="https://louisianabizhub.com/resources/?filter5Ids=44791&serviceCategoryIds=3160338&serviceIds=209498&sort_by=&user_sorted=&slrn_submit=1"
                target="_blank"
              >
                {window.location.hostname === 'la.caat.io' ? "Louisiana Business Hub's Resource Navigator" : "Business Hub's Resource Navigator"}
              </a>
            )}
          </p>
        </Alert>
      </Col>
    </Row>
  )
}

export default BusinessSearchResourcesNotice;
